module.exports = "/images/Book_Now_No_Text.png?03f9aec3325ddc90d390b3cf651d3973";